import InspectionsTable from "../components/inspections-table/InspectionsTable";
import React from "react";

function Inspections() {
    return <InspectionsTable />;
}

export default Inspections;
